<script lang="ts">
  import BindConfig from '$components/BindConfig/BindConfig.svelte';
  import type { BindContentConfig } from '$components/BindContent/bind-content.types';
  import VersionBadge from '$components/VersionBadge/VersionBadge.svelte';

  export let config: any;
  export let slug: string;
  export let scancodeConfig: BindContentConfig;
  export let referenceUrl: string;
</script>

<li class="example">
  <div class="header">
    <h3 class="title">{config.name}</h3>
    <VersionBadge long value={config.gameVersion || 'both'} modifiers={['large', 'no-shrink']} />
  </div>
  <div class="main">
    <div class="desc">
      <p>{config.description}</p>
    </div>
    <BindConfig
      config={scancodeConfig}
      command={config}
      {slug}
      allowDownload={false}
      hideVersion={true}
      cunModal={{
        referenceUrl,
        forceValues: () => ({
          variationTitle: config.name,
        }),
      }}
    />
  </div>
</li>

<style lang="scss">
  .example {
    // background-color: rgba(255, 255, 255, 0.05);
    // border-top: 1px solid rgba(255, 255, 255, 0.1);

    .header {
      border-bottom: 1px solid rgba(255, 255, 255, 0.02);
      border-top: 1px solid rgba(255, 255, 255, 0.02);
      background-color: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-flow: row wrap;
      gap: 1rem;

      h3 {
        margin: 0;
        flex-shrink: 0;
      }
    }

    .header,
    .main {
      padding: $gutter;
    }

    .main {
      font-size: 1.3rem;

      .desc {
        margin-bottom: $gutter;
        color: $col-light-3;
      }
    }
  }
</style>
